// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Decco = require("decco/src/Decco.bs.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Selector$SmartcutsMacros = require("../Selector.bs.js");

function semanticError_encode(v) {
  switch (v.TAG | 0) {
    case /* SuffixNotFound */0 :
        return [
                "SuffixNotFound",
                Decco.stringToJson(v._0),
                Decco.stringToJson(v._1)
              ];
    case /* NoneOfSuffixesFound */1 :
        return [
                "NoneOfSuffixesFound",
                Decco.arrayToJson(Decco.stringToJson, v._0),
                Decco.stringToJson(v._1)
              ];
    case /* PrefixNotFound */2 :
        return [
                "PrefixNotFound",
                Decco.stringToJson(v._0),
                Decco.stringToJson(v._1)
              ];
    case /* StartIndexOutOfBounds */3 :
        return [
                "StartIndexOutOfBounds",
                Decco.intToJson(v._0),
                Decco.stringToJson(v._1)
              ];
    case /* EndIndexOutOfBounds */4 :
        return [
                "EndIndexOutOfBounds",
                Decco.intToJson(v._0),
                Decco.stringToJson(v._1)
              ];
    case /* ExpectedTextNodeButGotAnotherNodeType */5 :
        return [
                "ExpectedTextNodeButGotAnotherNodeType",
                Selector$SmartcutsMacros.selector_encode(v._0)
              ];
    
  }
}

function semanticError_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "EndIndexOutOfBounds" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* EndIndexOutOfBounds */4,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "ExpectedTextNodeButGotAnotherNodeType" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Selector$SmartcutsMacros.selector_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ExpectedTextNodeButGotAnotherNodeType */5,
                      _0: v0._0
                    }
                  };
          }
          var e$2 = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "NoneOfSuffixesFound" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$3 = Decco.arrayFromJson(Decco.stringFromJson, Belt_Array.getExn(jsonArr$1, 1));
          var match$4 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$3.TAG === /* Ok */0) {
            if (match$4.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* NoneOfSuffixesFound */1,
                        _0: match$3._0,
                        _1: match$4._0
                      }
                    };
            }
            var e$3 = match$4._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$3.path,
                      message: e$3.message,
                      value: e$3.value
                    }
                  };
          }
          var e$4 = match$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      case "PrefixNotFound" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$5 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$6 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$5.TAG === /* Ok */0) {
            if (match$6.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* PrefixNotFound */2,
                        _0: match$5._0,
                        _1: match$6._0
                      }
                    };
            }
            var e$5 = match$6._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$5.path,
                      message: e$5.message,
                      value: e$5.value
                    }
                  };
          }
          var e$6 = match$5._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
      case "StartIndexOutOfBounds" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$7 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$8 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$7.TAG === /* Ok */0) {
            if (match$8.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* StartIndexOutOfBounds */3,
                        _0: match$7._0,
                        _1: match$8._0
                      }
                    };
            }
            var e$7 = match$8._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$7.path,
                      message: e$7.message,
                      value: e$7.value
                    }
                  };
          }
          var e$8 = match$7._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$8.path,
                    message: e$8.message,
                    value: e$8.value
                  }
                };
      case "SuffixNotFound" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$9 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$10 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$9.TAG === /* Ok */0) {
            if (match$10.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* SuffixNotFound */0,
                        _0: match$9._0,
                        _1: match$10._0
                      }
                    };
            }
            var e$9 = match$10._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$9.path,
                      message: e$9.message,
                      value: e$9.value
                    }
                  };
          }
          var e$10 = match$9._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$10.path,
                    message: e$10.message,
                    value: e$10.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

exports.semanticError_encode = semanticError_encode;
exports.semanticError_decode = semanticError_decode;
/* Selector-SmartcutsMacros Not a pure module */
